import { gql } from '@apollo/client';

export const sendGeneralTransferDetailsMutation = gql`
mutation SendGeneralTransferDetails($id: String!, $input: GeneralTransferDetailsInput!) {
    sendGeneralTransferDetails(id: $id, input: $input)
  }
`;